import ReceivementPlans from "./views/receivement/Plans.vue";
import { createRouter, createWebHistory } from "vue-router";
import AuditInteractions from "./components/audit/AuditInteractions.vue";
import Visitor from "./components/fingerprint/Visitor.vue";
import Test from "./views/Test.vue";
import Analytics from "./views/analytics/Analytics.vue";
import ActiveUsers from "./views/analytics/compliance/ActiveUsers.vue";
import ComplianceAnalytics from "./views/analytics/compliance/ComplianceAnalytics.vue";
import ComplianceProducts from "./views/analytics/compliance/products/ComplianceProducts.vue";
import ComplianceUsers from "./views/analytics/compliance/users/ComplianceUsers.vue";
import OrderAnalytics from "./views/analytics/orders/OrderAnalytics.vue";
import Antifraud from "./views/antifraud/Antifraud.vue";
import Audit from "./views/audit/Audit.vue";
import AuditBatches from "./views/audit/AuditBatches.vue";
import Audits from "./views/audit/Audits.vue";
import AuditMetrics from "./views/audit/metrics/AuditMetrics.vue";
import AuditoriaLayout from "./views/auditoria/AuditoriaLayout.vue";
import InviteMemberDetails from "./views/auditoria/InviteMemberDetails.vue";
import InviteMembers from "./views/auditoria/InviteMembers.vue";
import MozartAuditoria from "./views/auditoria/MozartAuditoria.vue";
import AuthLayout from "./views/auth/AuthLayout.vue";
import Login from "./views/auth/Login.vue";
import ValidateDevice from "./views/auth/ValidateDevice.vue";
import Blacklist from "./views/blacklist/Blacklist.vue";
import Chat from "./views/chat/Chat.vue";
import CreditCardForm from "./views/checkout/CreditCardForm.vue";
import Compliance from "./views/compliance/Compliance.vue";
import ComplianceDetails from "./views/compliance/ComplianceDetails.vue";
import FdicSubmissions from "./views/fdic/Submissions.vue";
import FdicSubmissionDetail from "./views/fdic/SubmissionDetail.vue";
import FdicSubmissionHistory from "./views/fdic/SubmissionHistory.vue";
import FdicBatchSubmit from "./views/fdic/BatchSubmit.vue";
import Config from "./views/config/Config.vue";
import FeatureFlags from "./views/config/FeatureFlags.vue";
import LegalTerms from "./views/config/LegalTerms.vue";
import PlatformSettings from "./views/config/PlatformSettings.vue";
import Reasons from "./views/config/Reasons.vue";
import Costs from "./views/costs/Costs.vue";
import CurrencyGateways from "./views/currencyGateways/CurrencyGateways.vue";
import Emails from "./views/emails/Emails.vue";
import AnticipationControl from "./views/finnancial/AnticipationControl.vue";
import BankAccount from "./views/finnancial/BankAccount.vue";
import BankAccounts from "./views/finnancial/BankAccounts.vue";
import CashoutControl from "./views/finnancial/CashoutControl.vue";
import CashoutReviews from "./views/finnancial/CashoutReviews.vue";
import Dashboard from "./views/finnancial/Dashboard.vue";
import FinnancialLayout from "./views/finnancial/FinnancialLayout.vue";
import Payables from "./views/finnancial/Payables.vue";
import ReviewsCockpit from "./views/finnancial/ReviewsCockpit.vue";
import AnticipationDetails from "./views/finnancial/anticipation/AnticipationDetails.vue";
import BalanceReserveReport from "./views/finnancial/balance-reserve/BalanceReserveReport.vue";
import BillingReport from "./views/finnancial/billing/BillingReport.vue";
import BlockedProducts from "./views/finnancial/cashout-release/BlockedProducts.vue";
import ProductUsersRelease from "./views/finnancial/cashout-release/ProductUsersRelease.vue";
import ReleaseHistory from "./views/finnancial/cashout-release/ReleaseHistory.vue";
import CashoutDetails from "./views/finnancial/cashout/CashoutDetails.vue";
import Chargebacks from "./views/finnancial/chargebacks/Chargebacks.vue";
import Dispute from "./views/finnancial/chargebacks/disputes/Dispute.vue";
import Disputes from "./views/finnancial/chargebacks/disputes/Disputes.vue";
import PreChargebacks from "./views/finnancial/chargebacks/preckb/PreChargebacks.vue";
import ChargebackReview from "./views/finnancial/chargebacks/reviews/Review.vue";
import ChargebackReviews from "./views/finnancial/chargebacks/reviews/Reviews.vue";
import TransactionImport from "./views/finnancial/chargebacks/transaction-import/TransactionImport.vue";
import ChargebackUser from "./views/finnancial/chargebacks/users/ChargebackUser.vue";
import ChargebackUsers from "./views/finnancial/chargebacks/users/ChargebackUsers.vue";
import TransferDetails from "./views/finnancial/transfers/TransferDetails.vue";
import Transfers from "./views/finnancial/transfers/Transfers.vue";
import KycDashboard from "./views/kyc/Dashboard.vue";
import KycBiometricRevalidation from "./views/kyc/BiometricRevalidation.vue";
import KycLayout from "./views/kyc/KycLayout.vue";
import SidebarApp from "./views/layouts/SidebarApp.vue";
import AccountManagers from "./views/managers/AccountManagers.vue";
import Mobile from "./views/mobile/Mobile.vue";
import MobileTimeline from "./views/mobile/MobileTimeline.vue";
import TopicBulkSubscribe from "./views/mobile/TopicBulkSubscribe.vue";
import NoticesBanners from "./views/notices/Banners.vue";
import NoticesList from "./views/notices/List.vue";
import Notices from "./views/notices/Notices.vue";
import Order from "./views/orders/Order.vue";
import OrderSearch from "./views/orders/OrderSearch.vue";
import Orders from "./views/orders/Orders.vue";
import NextPlate from "./views/account-portfolio/NextPlate.vue";
import CurrentPlate from "./views/account-portfolio/CurrentPlate.vue";
import AccountPortfolioLayout from "./views/account-portfolio/AccountPortfolioLayout.vue";
import Campaign from "./views/campaigns/Campaign.vue";
import Campaigns from "./views/campaigns/Campaigns.vue";
import CheckoutOps from "./views/operations/CheckoutOps.vue";
import Nexus from "./views/nexus/Nexus.vue";
import PixRecurringAudit from "./views/pix-recurring/PixRecurringAudit.vue";
import Product from "./views/products/Product.vue";
import Products from "./views/products/Products.vue";
import ProductCoupons from "./views/products/coupons/ProductCoupons.vue";
import ProductInteractions from "./views/products/interactions/ProductInteractions.vue";
import ProductMemberArea from "./views/products/members/ProductMemberArea.vue";
import MemberAreaContents from "./views/products/members/resources/MemberAreaContents.vue";
import MemberAreaLessons from "./views/products/members/resources/MemberAreaLessons.vue";
import MemberAreaModules from "./views/products/members/resources/MemberAreaModules.vue";
import ProductStudents from "./views/products/students/ProductStudents.vue";
import RankingLayout from "./views/ranking/RankingLayout.vue";
import Achievements from "./views/ranking/achievements/Achievements.vue";
import Levels from "./views/ranking/levels/Levels.vue";
import Plates from "./views/ranking/plates/Plates.vue";
import Ranking from "./views/ranking/ranking/Ranking.vue";
import Release from "./views/release/Release.vue";
import ReleaseDetails from "./views/release/details/Details.vue";
import RiskDashboard from "./views/risk/Dashboard.vue";
import S3 from "./views/s3/S3.vue";
import SectorLeaders from "./views/sectors/SectorLeaders.vue";
import SectorLeadersList from "./views/sectors/SectorLeadersList.vue";
import SectorManagement from "./views/sectors/SectorManagement.vue";
import SectorMembers from "./views/sectors/SectorMembers.vue";
import AccountWindowMetrics from "./views/account-window-metrics/AccountWindowMetrics.vue";
import SellerAgeAnalysis from "./views/seller-age-analysis/SellerAgeAnalysis.vue";
import Sellers from "./views/sellers/Sellers.vue";
import EvolutionAPI from "./views/services/EvolutionApi.vue";
import Services from "./views/services/Services.vue";
import ShippingProviders from "./views/services/ShippingProviders.vue";
import ViewAIPlans from "./views/services/ViewAI/Plans.vue";
import ViewAIUsers from "./views/services/ViewAI/Users.vue";
import Zapi from "./views/services/Zapi.vue";
import Recommended from "./views/showcase/Recommended.vue";
import ShowcaseSettings from "./views/showcase/Settings.vue";
import ShowcaseLayout from "./views/showcase/ShowcaseLayout.vue";
import Singlestore from "./views/singlestore/Singlestore.vue";
import Translations from "./views/translations/Translations.vue";
import Profile from "./views/users/Profile.vue";
import Referrals from "./views/users/Referrals.vue";
import Relations from "./views/users/Relations.vue";
import User from "./views/users/User.vue";
import UserImpersonateHistory from "./views/users/UserImpersonateHistory.vue";
import ImportStudents from "./views/users/import-students/ImportStudents.vue";
import Users from "./views/users/Users.vue";
import AuditUserAffiliates from "./views/users/audit/AuditUserAffiliates.vue";
import AuditUserCommissions from "./views/users/audit/AuditUserCommissionsRedesign.vue";
import AuditUserFinnancial from "./views/users/audit/AuditUserFinnancial.vue";
import AuditUserMetrics from "./views/users/audit/AuditUserMetrics.vue";
import AuditUserProducts from "./views/users/audit/AuditUserProducts.vue";
import UserAudit from "./views/users/audit/UserAudit.vue";
import UserLogins from "./views/users/audit/UserLogins.vue";
import UserTrackings from "./views/users/audit/UserTrackings.vue";
import Commissions from "./views/users/commissions/Commissions.vue";
import UserFinancial from "./views/users/financial/UserFinancial.vue";
import Permissions from "./views/users/permissions/Permissions.vue";
import UserPlates from "./views/users/plates/UserPlates.vue";
import UserProducts from "./views/users/products/UserProducts.vue";
import UserSettings from "./views/users/settings/UserSettings.vue";
import AnticipationHistories from "./views/users/statement/AnticipationHistories.vue";
import Statement from "./views/users/statement/Statement.vue";
import StatementLog from "./views/users/statement/StatementLog.vue";
import Videos from "./views/videos/Videos.vue";
import Webhooks from "./views/webhooks/Webhooks.vue";


const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: "/test",
            component: Test,
            name: "test",
            meta: { title: "Test" },
        },
        {
            component: SidebarApp,
            children: [
                {
                    path: "/sectors",
                    component:
                        SectorManagement /* webpackChunkName: "sectors" */,
                    name: "sectors",
                    meta: { title: "Setores" },
                },
                {
                    path: "/sectors/:role_id",
                    component: SectorMembers /* webpackChunkName: "sectors" */,
                    name: "sector.members",
                    meta: { title: "Membros do Setor" },
                },
                {
                    path: "/sectors/:role_id/leaders",
                    component: SectorLeaders /* webpackChunkName: "sectors" */,
                    name: "sector.leaders",
                    meta: { title: "Líderes do Setor" },
                },
                {
                    path: "/sectors/leaders",
                    component:
                        SectorLeadersList /* webpackChunkName: "sectors" */,
                    name: "sector.leaders.all",
                    meta: { title: "Lista de Líderes de Setores" },
                },
                {
                    path: "/s3",
                    component: S3 /* webpackChunkName: "system" */,
                    name: "s3",
                    meta: { title: "S3" },
                },
                {
                    path: "/receivement-plans",
                    name: "receivement.plans",
                    component: ReceivementPlans,
                    meta: { title: "Planos de Recebimento" },
                },
                {
                    path: "/user",
                    component: Users,
                    name: "users",
                    meta: { title: "Usuários" },
                },
                {
                    path: "/operations/checkout",
                    component: CheckoutOps,
                    name: "operations.checkout",
                    meta: { title: "Operações do Checkout" },
                },
                {
                    path: "/seller-age-analysis",
                    component: SellerAgeAnalysis,
                    name: "seller.age.analysis",
                    meta: { title: "Análise de Idade de Vendedores" },
                },
                {
                    path: "/account-window-metrics",
                    component: AccountWindowMetrics,
                    name: "account.window.metrics",
                    meta: { title: "Janelas de Risco" },
                },
                {
                    path: "/profile",
                    component: Profile,
                    name: "profile",
                    meta: { title: "Perfil" },
                },
                {
                    path: "/chat",
                    component: Chat /* webpackChunkName: "communication" */,
                    name: "chat",
                    meta: { title: "Chat" },
                },
                {
                    path: "/audit",
                    component: Audits,
                    name: "audit",
                    meta: { title: "Auditoria" },
                },
                {
                    path: "/sellers",
                    component: Sellers /* webpackChunkName: "sellers" */,
                    name: "sellers",
                    meta: { title: "Sellers" },
                },
                {
                    path: "/webhooks",
                    component: Webhooks /* webpackChunkName: "system" */,
                    name: "webhooks",
                    meta: { title: "Webhooks" },
                },
                {
                    path: "/audit/metrics",
                    component: AuditMetrics,
                    name: "audit.metrics",
                    meta: { title: "Auditoria" },
                },
                {
                    path: "/audit/:audit_id",
                    component: Audit,
                    name: "audit.single",
                    meta: { title: "Auditoria" },
                    children: [
                        {
                            path: "interactions",
                            name: "audit.interactions",
                            component: AuditInteractions,
                        },
                        {
                            path: "metrics",
                            name: "audit.metrics",
                            component: AuditUserMetrics,
                        },
                        {
                            path: "trackings",
                            name: "audit.trackings",
                            component: UserTrackings,
                        },
                        {
                            path: "products",
                            name: "audit.products",
                            component: AuditUserProducts,
                        },
                        {
                            path: "commissions",
                            name: "audit.commissions",
                            component: AuditUserCommissions,
                        },
                        {
                            path: "logins",
                            name: "audit.logins",
                            component: UserLogins,
                        },
                        {
                            path: "finnancial",
                            name: "audit.finnancial",
                            component: AuditUserFinnancial,
                            meta: { title: "Financeiro" },
                        },
                    ],
                },
                {
                    path: "/visitor",
                    component: Visitor,
                    name: "visitor",
                    meta: { title: "Visitante" },
                },
                {
                    path: "/antifraud",
                    component: Antifraud,
                    name: "antifraud",
                    meta: { title: "Antifraude" },
                },
                {
                    path: "/translations",
                    component: Translations /* webpackChunkName: "system" */,
                    name: "translations",
                    meta: { title: "Traduções" },
                },
                {
                    path: "/singlestore",
                    component: Singlestore /* webpackChunkName: "system" */,
                    name: "singlestore",
                    meta: { title: "Singlestore" },
                },
                {
                    path: "/visitor/:visitor_id",
                    component: Visitor,
                    name: "visitor.events",
                    meta: { title: "Visitante" },
                },
                {
                    path: "/compliance",
                    name: "compliance",
                    meta: { title: "Compliance" },
                    component: Compliance,
                },
                {
                    path: "/emails",
                    name: "emails",
                    meta: { title: "Emails" },
                    component: Emails /* webpackChunkName: "communication" */,
                },
                {
                    path: "/account-managers",
                    name: "account-managers",
                    meta: { title: "Gerentes" },
                    component:
                        AccountManagers /* webpackChunkName: "management" */,
                },
                {
                    path: "/notices",
                    name: "notices",
                    meta: { title: "Avisos" },
                    component: Notices /* webpackChunkName: "notices" */,
                    children: [
                        {
                            path: "list",
                            name: "notices.list",
                            component:
                                NoticesList /* webpackChunkName: "notices" */,
                        },
                        {
                            path: "banners",
                            name: "notices.banners",
                            component:
                                NoticesBanners /* webpackChunkName: "notices" */,
                        },
                    ],
                },
                {
                    path: "/credit-card",
                    name: "credit-card",
                    meta: { title: "Cartões" },
                    component: CreditCardForm /* webpackChunkName: "payment" */,
                },
                {
                    path: "/mobile",
                    name: "mobile",
                    meta: { title: "Mobile" },
                    component: Mobile /* webpackChunkName: "mobile" */,
                },
                {
                    path: "/mobile/timeline",
                    name: "mobile.timeline",
                    meta: { title: "Mobile Timeline" },
                    component: MobileTimeline /* webpackChunkName: "mobile" */,
                },
                {
                    path: "/mobile/bulk-subscribe",
                    name: "mobile.bulk-subscribe",
                    meta: { title: "Inscrição em Massa" },
                    component: TopicBulkSubscribe /* webpackChunkName: "mobile" */,
                },
                {
                    path: "/videos",
                    name: "videos",
                    meta: { title: "Videos" },
                    component: Videos /* webpackChunkName: "content" */,
                },
                {
                    path: "/release",
                    name: "release",
                    meta: { title: "Release Notes" },
                    component: Release,
                },
                {
                    path: "/release/:release_id",
                    name: "release.details",
                    meta: { title: "Release" },
                    component: ReleaseDetails,
                },
                {
                    path: "/compliance/:user_id",
                    name: "compliance.details",
                    meta: { title: "Compliance" },
                    component: ComplianceDetails,
                },
                {
                    path: "/fdic",
                    name: "fdic.submissions",
                    meta: { title: "FDIC" },
                    component: FdicSubmissions,
                },
                {
                    path: "/fdic/batch",
                    name: "fdic.batch",
                    meta: { title: "FDIC — Envio em Lote" },
                    component: FdicBatchSubmit,
                },
                {
                    path: "/fdic/user/:userId/history",
                    name: "fdic.history",
                    meta: { title: "FDIC — Histórico do Cedente" },
                    component: FdicSubmissionHistory,
                },
                {
                    path: "/fdic/:id",
                    name: "fdic.detail",
                    meta: { title: "FDIC — Detalhe" },
                    component: FdicSubmissionDetail,
                },
                {
                    path: "/auditoria",
                    name: "auditoria",
                    meta: { title: "Auditoria" },
                    component: AuditoriaLayout,
                    children: [
                        {
                            path: "mozart",
                            name: "auditoria.mozart",
                            component: MozartAuditoria,
                            meta: { title: "Mozart" },
                                                        children: [
                                {
                                    path: "invite-members",
                                    name: "auditoria.mozart.invite-members",
                                    component: InviteMembers,
                                    meta: { title: "Invite Members" },
                                },
                                {
                                    path: "invite-members/:user",
                                    name: "auditoria.mozart.invite-member-details",
                                    component: InviteMemberDetails,
                                    meta: { title: "Detalhes do Membro" },
                                },
                            ],
                        },
                    ],
                },
                {
                    path: "/user/:user_id",
                    name: "user.details" /* webpackChunkName: "users" */,
                    meta: { title: "Usuário" },
                    component: User,
                    children: [
                        {
                            path: "audit",
                            name: "user.audit",
                            component:
                                UserAudit /* webpackChunkName: "users-audit" */,
                            children: [
                                {
                                    path: "metrics",
                                    name: "user.metrics",
                                    component:
                                        AuditUserMetrics /* webpackChunkName: "users-audit-metrics" */,
                                },
                                {
                                    path: "trackings",
                                    name: "user.trackings",
                                    component:
                                        UserTrackings /* webpackChunkName: "users-audit-trackings" */,
                                },
                                {
                                    path: "products",
                                    name: "user.audit.products",
                                    component:
                                        AuditUserProducts /* webpackChunkName: "users-audit-products" */,
                                },
                                {
                                    path: "commissions",
                                    name: "user.audit.commissions",
                                    component:
                                        AuditUserCommissions /* webpackChunkName: "users-audit-commissions" */,
                                },
                                {
                                    path: "logins",
                                    name: "user.audit.logins",
                                    component:
                                        UserLogins /* webpackChunkName: "users-audit-logins" */,
                                },
                                {
                                    path: "finnancial",
                                    name: "user.audit.finnancial",
                                    component:
                                        AuditUserFinnancial /* webpackChunkName: "users-audit-financial" */,
                                    meta: { title: "Financeiro" },
                                },
                                {
                                    path: "affiliates",
                                    name: "user.audit.affiliates",
                                    component:
                                        AuditUserAffiliates /* webpackChunkName: "users-audit-affiliates" */,
                                },
                            ],
                        },
                        {
                            path: "commissions",
                            name: "user.commissions",
                            component:
                                Commissions /* webpackChunkName: "users-commissions" */,
                        },
                        {
                            path: "relations",
                            name: "user.relations",
                            component:
                                Relations /* webpackChunkName: "users-relations" */,
                        },
                        {
                            path: "referrals",
                            name: "user.referrals",
                            component:
                                Referrals /* webpackChunkName: "users-referrals" */,
                        },
                        {
                            path: "statement",
                            name: "user.statement",
                            component:
                                Statement /* webpackChunkName: "users-statement" */,
                        },
                        {
                            path: "log",
                            name: "user.statement-log",
                            component:
                                StatementLog /* webpackChunkName: "users-statement-log" */,
                        },
                        {
                            path: "anticipation/histories",
                            name: "user.anticipation-histories",
                            component:
                                AnticipationHistories /* webpackChunkName: "users-anticipation" */,
                        },
                        {
                            path: "permissions",
                            name: "user.permissions",
                            component:
                                Permissions /* webpackChunkName: "users-permissions" */,
                        },
                        {
                            path: "details",
                            name: "user.settings",
                            component:
                                UserSettings /* webpackChunkName: "users-settings" */,
                        },
                        {
                            path: "financial",
                            name: "user.financial",
                            component:
                                UserFinancial /* webpackChunkName: "users-financial" */,
                        },
                        {
                            path: "products",
                            name: "user.products",
                            component:
                                UserProducts /* webpackChunkName: "users-products" */,
                        },
                        {
                            path: "plates",
                            name: "user.plates",
                            component:
                                UserPlates /* webpackChunkName: "users-plates" */,
                        },
                        {
                            path: "history",
                            name: "user.history",
                            component: UserImpersonateHistory,
                        },
                        {
                            path: "import-students",
                            name: "user.import-students",
                            component: ImportStudents,
                        },
                    ],
                },
                {
                    path: "/products",
                    name: "products",
                    component: Products /* webpackChunkName: "products" */,
                    meta: { title: "Produtos" },
                },
                {
                    path: "/product/:product_id",
                    name: "product",
                    component: Product /* webpackChunkName: "products" */,
                    meta: { title: "Produto" },
                },
                {
                    path: "/product/:product_id/interactions",
                    name: "product.interactions",
                    component: ProductInteractions,
                    meta: { title: "Interações" },
                },
                {
                    path: "/product/:product_id/members",
                    name: "product.members",
                    component:
                        ProductMemberArea /* webpackChunkName: "products-members" */,
                    meta: { title: "Área de membros" },
                    children: [
                        {
                            path: "contents",
                            name: "product.members.contents",
                            component:
                                MemberAreaContents /* webpackChunkName: "products-members" */,
                        },
                        {
                            path: "modules",
                            name: "product.members.modules",
                            component:
                                MemberAreaModules /* webpackChunkName: "products-members" */,
                        },
                        {
                            path: "lessons",
                            name: "product.members.lessons",
                            component:
                                MemberAreaLessons /* webpackChunkName: "products-members" */,
                        },
                    ],
                },
                {
                    path: "/product/:product_id/coupons",
                    name: "product.coupons",
                    component: ProductCoupons /* webpackChunkName: "products-coupons" */,
                    meta: { title: "Cupons" },
                },
                {
                    path: "/product/:product_id/students",
                    name: "product.students",
                    component:
                        ProductStudents /* webpackChunkName: "products" */,
                    meta: { title: "Alunos" },
                },
                {
                    path: "/orders",
                    name: "orders",
                    component: Orders /* webpackChunkName: "orders" */,
                    meta: { title: "Pedidos" },
                },
                {
                    path: "/orders/search",
                    name: "orders.search",
                    component: OrderSearch /* webpackChunkName: "orders" */,
                    meta: { title: "Pedidos" },
                },
                {
                    path: "/nexus",
                    name: "nexus",
                    component: Nexus /* webpackChunkName: "nexus" */,
                    meta: { title: "Nexus" },
                },
                {
                    path: "/order/:order_id",
                    name: "user.order",
                    component: Order /* webpackChunkName: "orders" */,
                    meta: { title: "Pedido" },
                },
                {
                    path: "/pix-recurring/audit",
                    name: "pix-recurring-audit",
                    component: PixRecurringAudit /* webpackChunkName: "pix-recurring" */,
                    meta: {
                        title: "Auditoria PIX Recorrente",
                        requiresAuth: true
                    },
                },
                {
                    path: "/analytics",
                    name: "analytics",
                    component: Analytics /* webpackChunkName: "analytics" */,
                    meta: { title: "Analytics" },
                    children: [
                        {
                            path: "compliance",
                            name: "analytics.compliance",
                            component:
                                ComplianceAnalytics /* webpackChunkName: "analytics-compliance" */,
                            children: [
                                {
                                    path: "users",
                                    name: "analytics.compliance.users",
                                    component:
                                        ComplianceUsers /* webpackChunkName: "analytics-compliance" */,
                                },
                                {
                                    path: "products",
                                    name: "analytics.compliance.products",
                                    component:
                                        ComplianceProducts /* webpackChunkName: "analytics-compliance" */,
                                },
                            ],
                        },
                        {
                            path: "orders",
                            name: "analytics.orders",
                            component:
                                OrderAnalytics /* webpackChunkName: "analytics-orders" */,
                        },
                        {
                            path: "active-users",
                            name: "analytics.active-users",
                            component:
                                ActiveUsers /* webpackChunkName: "analytics-users" */,
                        },
                    ],
                },
                {
                    component: KycLayout,
                    path: "/kyc",
                    meta: { title: "KYC" },
                    children: [
                        {
                            path: "dashboard",
                            name: "kyc.dashboard",
                            component: KycDashboard,
                        },
                        {
                            path: "biometric-revalidation",
                            name: "kyc.biometric-revalidation",
                            component: KycBiometricRevalidation,
                        },
                    ],
                },
                {
                    component: FinnancialLayout,
                    path: "/financial",
                    meta: { title: "Financeiro" },
                    children: [
                        {
                            path: "dashboard",
                            name: "finnancial.dashboard",
                            component:
                                Dashboard /* webpackChunkName: "financial" */,
                        },
                        {
                            path: "chargebacks",
                            name: "finnancial.chargebacks",
                            component: Chargebacks /* webpackChunkName: "financial-chargebacks" */,
                            redirect: { name: "finnancial.chargebacks.users" },
                            children: [
                                {
                                    path: "disputes",
                                    name: "finnancial.chargebacks.disputes",
                                    component:
                                        Disputes /* webpackChunkName: "financial-chargebacks" */,
                                },
                                {
                                    path: "disputes/:dispute_id",
                                    name: "finnancial.chargebacks.dispute",
                                    component:
                                        Dispute /* webpackChunkName: "financial-chargebacks" */,
                                },
                                {
                                    path: "users",
                                    name: "finnancial.chargebacks.users",
                                    component:
                                        ChargebackUsers /* webpackChunkName: "financial-chargebacks" */,
                                },
                                {
                                    path: "users/:user_id",
                                    name: "finnancial.chargebacks.user",
                                    component:
                                        ChargebackUser /* webpackChunkName: "financial-chargebacks" */,
                                },
                                {
                                    path: "pre-chargebacks",
                                    name: "finnancial.chargebacks.pre-chargebacks",
                                    component:
                                        PreChargebacks /* webpackChunkName: "financial-chargebacks" */,
                                },
                                {
                                    path: "transaction-import",
                                    name: "finnancial.chargebacks.transaction-import",
                                    component:
                                        TransactionImport /* webpackChunkName: "financial-chargebacks" */,
                                },
                                {
                                    path: "reviews",
                                    name: "finnancial.chargebacks.reviews",
                                    component: ChargebackReviews /* webpackChunkName: "financial-chargebacks" */,
                                },
                                {
                                    path: "reviews/:review_id",
                                    name: "finnancial.chargebacks.review",
                                    component: ChargebackReview /* webpackChunkName: "financial-chargebacks" */,
                                },
                            ],
                        },
                        {
                            path: "payables",
                            name: "finnancial.payables",
                            component:
                                Payables /* webpackChunkName: "financial" */,
                        },
                        {
                            path: "transfers",
                            name: "finnancial.transfers",
                            component: Transfers /* webpackChunkName: "financial-transfers" */,
                        },
                        {
                            path: "billing-report",
                            name: "finnancial.billing-report",
                            component: BillingReport /* webpackChunkName: "financial-billing" */,
                            meta: { title: "Faturamento" },
                        },
                        {
                            path: "reservas-saldo",
                            name: "finnancial.balance-reserve-report",
                            component: BalanceReserveReport /* webpackChunkName: "financial-balance-reserve" */,
                            meta: { title: "Reservas de Saldo" },
                        },
                        {
                            path: "bank-accounts",
                            name: "finnancial.bank-accounts",
                            component:
                                BankAccounts /* webpackChunkName: "financial" */,
                        },
                        {
                            path: "cashout-control",
                            redirect: {
                                name: "finnancial.cashout-control",
                            },
                        },
                        {
                            path: "cashouts",
                            name: "finnancial.cashout-control",
                            component:
                                CashoutControl /* webpackChunkName: "financial-cashout" */,
                        },
                        {
                            path: "anticipation-control",
                            name: "finnancial.anticipation-control",
                            component:
                                AnticipationControl /* webpackChunkName: "financial-anticipation" */,
                        },
                        {
                            path: "reviews",
                            name: "finnancial.reviews",
                            component:
                                CashoutReviews /* webpackChunkName: "financial-reviews" */,
                            meta: { title: "Reviews - Financeiro" },
                        },
                        {
                            path: "reviews/cockpit",
                            name: "finnancial.reviews.cockpit",
                            component:
                                ReviewsCockpit /* webpackChunkName: "financial-reviews" */,
                            meta: { title: "Reviews - Financeiro" },
                        },
                        {
                            path: "costs",
                            name: "costs",
                            component:
                                Costs /* webpackChunkName: "financial-costs" */,
                            meta: { title: "Custos Mensais" },
                        },
                        {
                            path: "currency-gateway",
                            name: "finnancial.currency-gateway",
                            component:
                                CurrencyGateways /* webpackChunkName: "financial" */,
                            meta: { title: "Moedas" },
                        },
                        {
                            path: "cashout-release/blocked-products",
                            name: "finnancial.cashout-release.blocked-products",
                            component: BlockedProducts /* webpackChunkName: "financial-cashout-release" */,
                            meta: { title: "Produtos Bloqueados" },
                        },
                        {
                            path: "cashout-release/history",
                            name: "finnancial.cashout-release.history",
                            component: ReleaseHistory /* webpackChunkName: "financial-cashout-release" */,
                            meta: { title: "Histórico de Liberações" },
                        },
                    ],
                },
                {
                    path: "/financial/cashout-release/product/:product_id",
                    name: "finnancial.cashout-release.product",
                    component: ProductUsersRelease /* webpackChunkName: "financial-cashout-release" */,
                    meta: { title: "Liberar Saque - Usuários" },
                },
                {
                    path: "/financial/bank-account/:account_id",
                    name: "finnancial.bank-account",
                    component: BankAccount /* webpackChunkName: "financial" */,
                    meta: { title: "Detalhes da Conta" },
                },
                {
                    path: "/financial/cashout-details/:cashout_id",
                    name: "finnancial.cashout-details",
                    component:
                        CashoutDetails /* webpackChunkName: "financial-cashout" */,
                    meta: { title: "Detalhes do Saque" },
                },
                {
                    path: "/financial/transfers/:transfer_id",
                    name: "finnancial.transfer-details",
                    component: TransferDetails /* webpackChunkName: "financial-transfers" */,
                    meta: { title: "Detalhes da Transferência" },
                },
                {
                    path: "/financial/anticipation-details/:anticipation_id",
                    name: "finnancial.anticipation-details",
                    component:
                        AnticipationDetails /* webpackChunkName: "financial-anticipation" */,
                    meta: { title: "Detalhes da Antecipação" },
                },

                {
                    component:
                        ShowcaseLayout /* webpackChunkName: "showcase" */,
                    path: "/showcase",
                    meta: { title: "Showcase" },
                    children: [
                        {
                            path: "settings",
                            name: "showcase.settings",
                            component:
                                ShowcaseSettings /* webpackChunkName: "showcase" */,
                        },
                        {
                            path: "recommended",
                            name: "showcase.recommended",
                            component:
                                Recommended /* webpackChunkName: "showcase" */,
                        },
                    ],
                },
                {
                    path: "/services",
                    name: "services",
                    component: Services /* webpackChunkName: "services" */,
                    meta: { title: "Serviços" },
                },
                {
                    path: "/services/zapi",
                    name: "services.zapi",
                    component: Zapi /* webpackChunkName: "services" */,
                },
                {
                    path: "/services/evolution-api",
                    name: "services.evolution-api",
                    component: EvolutionAPI /* webpackChunkName: "services" */,
                },
                {
                    path: "/services/viewai/plans",
                    name: "services.viewai.plans",
                    component:
                        ViewAIPlans /* webpackChunkName: "services-viewai" */,
                },
                {
                    path: "/services/viewai/users",
                    name: "services.viewai.users",
                    component:
                        ViewAIUsers /* webpackChunkName: "services-viewai" */,
                },
                {
                    path: "/services/shipping-providers",
                    name: "services.shipping-providers",
                    component:
                        ShippingProviders /* webpackChunkName: "services" */,
                },
                {
                    path: "/services/transfeera",
                    name: "services.transfeera",
                    component: () =>
                        import(
                            "./views/services/Transfeera.vue"
                        ) /* webpackChunkName: "services-transfeera" */,
                    meta: { title: "Integração Transfeera" },
                },
                {
                    path: "/services/transfeera/validations",
                    name: "services.transfeera.pix-validations",
                    component: () =>
                        import(
                            "./views/services/transfeera/PixValidations.vue"
                        ) /* webpackChunkName: "services-transfeera" */,
                    meta: { title: "Validações PIX - Transfeera" },
                },
                {
                    path: "/services/transfeera/webhooks",
                    name: "services.transfeera.webhook-logs",
                    component: () =>
                        import(
                            "./views/services/transfeera/WebhookLogs.vue"
                        ) /* webpackChunkName: "services-transfeera" */,
                    meta: { title: "Logs de Webhook - Transfeera" },
                },
                {
                    path: "/services/transfeera/batch-validations",
                    name: "services.transfeera.batch-validations",
                    component: () =>
                        import(
                            "./views/services/transfeera/BatchValidations.vue"
                        ) /* webpackChunkName: "services-transfeera" */,
                    meta: { title: "Validações em Lote - Transfeera" },
                },

                {
                    path: "/blacklist",
                    name: "blacklist.index",
                    component: Blacklist /* webpackChunkName: "blacklist" */,
                    meta: { title: "blacklist" },
                },
                {
                    path: "/campaigns",
                    name: "campaigns",
                    component: Campaigns /* webpackChunkName: "campaigns" */,
                    meta: { title: "Campanhas" },
                },
                {
                    path: "/campaign/create",
                    name: "campaign.create",
                    component: Campaign /* webpackChunkName: "campaigns" */,
                    meta: { title: "Nova Campanha" },
                },
                {
                    path: "/campaign/:campaign_id",
                    name: "campaign",
                    component: Campaign /* webpackChunkName: "campaigns" */,
                    meta: { title: "Campanha" },
                },
                {
                    path: "/config",
                    name: "config",
                    component: Config /* webpackChunkName: "config" */,
                    meta: { title: "Configurações" },
                    children: [
                        {
                            path: "reasons",
                            name: "reasons",
                            component: Reasons /* webpackChunkName: "config" */,
                        },
                        {
                            path: "legal-terms",
                            name: "legal-terms",
                            component:
                                LegalTerms /* webpackChunkName: "config" */,
                        },
                        {
                            path: "feature-flags",
                            name: "feature-flags",
                            component: FeatureFlags /* webpackChunkName: "config" */,
                        },
                        {
                            path: "platform-settings",
                            name: "platform-settings",
                            component: PlatformSettings /* webpackChunkName: "config" */,
                        }
                    ],
                },
                {
                    component: RankingLayout /* webpackChunkName: "ranking" */,
                    path: "/ranking",
                    meta: { title: "Ranking" },
                    children: [
                        {
                            path: "levels",
                            name: "ranking.levels",
                            component: Levels /* webpackChunkName: "ranking" */,
                        },
                        {
                            path: "achievements",
                            name: "ranking.achievements",
                            component:
                                Achievements /* webpackChunkName: "ranking" */,
                        },
                        {
                            path: "",
                            name: "ranking.ranking",
                            component:
                                Ranking /* webpackChunkName: "ranking" */,
                        },
                        {
                            path: "plates",
                            name: "ranking.plates",
                            component: Plates /* webpackChunkName: "ranking" */,
                        },
                    ],
                },
                {
                    component: AccountPortfolioLayout /* webpackChunkName: "account-portfolio" */,
                    path: "/account-portfolio",
                    meta: { title: "Carteiras" },
                    children: [
                        {
                            path: "",
                            name: "account-portfolio.next-plate",
                            component: NextPlate /* webpackChunkName: "account-portfolio" */,
                        },
                        {
                            path: "current-plate",
                            name: "account-portfolio.current-plate",
                            component: CurrentPlate /* webpackChunkName: "account-portfolio" */,
                        },
                    ],
                },
                {
                    path: "/risk/dashboard",
                    name: "risk.dashboard",
                    component: RiskDashboard /* webpackChunkName: "risk" */,
                    meta: {
                        requiresAuth: true,
                        title: "Dashboard de Risco",
                    },
                },
                {
                    path: "/audit-batches",
                    name: "audit.batches",
                    component: AuditBatches /* webpackChunkName: "audit" */,
                    meta: {
                        title: "Batches de Auditoria",
                        requiresAuth: true,
                    },
                },
                {
                    path: "/experimental-scoring",
                    name: "experimental-scoring",
                    component: () => import("./views/experimental-scoring/ExperimentalScoring.vue") /* webpackChunkName: "experimental-scoring" */,
                    redirect: { name: "experimental-scoring.rules" },
                    meta: {
                        title: "Scoring Experimental",
                        requiresAuth: true,
                        requiresAdmin: true,
                    },
                    children: [
                        {
                            path: "rules",
                            name: "experimental-scoring.rules",
                            component: () => import("./views/experimental-scoring/components/RuleControl.vue") /* webpackChunkName: "experimental-scoring" */,
                        },
                        {
                            path: "blocks",
                            name: "experimental-scoring.blocks",
                            component: () => import("./views/experimental-scoring/components/BlockAnalysis.vue") /* webpackChunkName: "experimental-scoring" */,
                        },
                        {
                            path: "history",
                            name: "experimental-scoring.history",
                            component: () => import("./views/experimental-scoring/HistoryTab.vue") /* webpackChunkName: "experimental-scoring" */,
                        },
                        {
                            path: "impact",
                            name: "experimental-scoring.impact",
                            component: () => import("./views/experimental-scoring/ImpactTab.vue") /* webpackChunkName: "experimental-scoring" */,
                        },
                        {
                            path: "comparison",
                            name: "experimental-scoring.comparison",
                            component: () => import("./views/experimental-scoring/ComparisonTab.vue") /* webpackChunkName: "experimental-scoring" */,
                        },
                        {
                            path: "simulation",
                            name: "experimental-scoring.simulation",
                            component: () => import("./views/experimental-scoring/SimulationTab.vue") /* webpackChunkName: "experimental-scoring" */,
                        },
                    ],
                },
                {
                    path: "/monitoring",
                    name: "monitoring",
                    component: () => import("./views/monitoring/MonitoringPanel.vue") /* webpackChunkName: "monitoring" */,
                    redirect: { name: "monitoring.incidents" },
                    meta: {
                        title: "Monitoramento",
                        requiresAuth: true,
                        requiresAdmin: true,
                    },
                    children: [
                        {
                            path: "overview",
                            name: "monitoring.overview",
                            component: () => import("./views/monitoring/OverviewTab.vue") /* webpackChunkName: "monitoring" */,
                        },
                        {
                            path: "incidents",
                            name: "monitoring.incidents",
                            component: () => import("./views/monitoring/IncidentsTab.vue") /* webpackChunkName: "monitoring" */,
                        },
                        {
                            path: "incidents/:incident_id",
                            name: "monitoring.incident",
                            component: () => import("./views/monitoring/IncidentDetail.vue") /* webpackChunkName: "monitoring" */,
                        },
                        {
                            path: "rules",
                            name: "monitoring.rules",
                            component: () => import("./views/monitoring/RulesTab.vue") /* webpackChunkName: "monitoring" */,
                        },
                    ],
                },
            ],
        },

        {
            path: "/auth",
            component: AuthLayout /* webpackChunkName: "auth" */,
            children: [
                {
                    path: "login",
                    name: "login",
                    component: Login /* webpackChunkName: "auth" */,
                    meta: { title: "Login" },
                },
                {
                    path: "validate-device/:uuid/",
                    name: "validateDevice",
                    component: ValidateDevice /* webpackChunkName: "auth" */,
                    meta: { title: "Login" },
                },
            ],
        },
    ],
});

export default router;
